export const generalReportsInvoices = {
  data () {
    return {
      val: false,
      groupBy: ['Invoice_Status'],
      search: '',
      searchProject: '',
      searchClient: '',
      searchDepartment: '',
      datesMenu: false,
      selectAllProjects: false,
      selectAllClients: false,
      selectAllDepartments: false,
      sortBy: undefined,
      sortDesc: undefined,
      filter: {
        Client_ID: [],
        Project_ID: [],
        DateRange: [],
        Dep_ID: []
      }
    }
  },
  mounted () {
    if (!this.projects.length) {
      this.getProjects()
    }
    if (!this.clients.length) {
      this.getClients()
    }
    if (!this.departments.length) {
      this.getDepartments()
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    projects () {
      const r = new RegExp(this.searchProject, 'gi')
      return this.$store.getters.getProjects.filter(item => {
        r.lastIndex = 0
        return r.test(item.Description)
      })
    },
    clients () {
      const r = new RegExp(this.searchClient, 'gi')
      return this.$store.getters.getClients.filter(item => {
        r.lastIndex = 0
        return r.test(item.Name)
      })
    },
    departments () {
      const r = new RegExp(this.searchDepartment, 'gi')
      if (this.searchDepartment) {
        return this.$store.getters.getDepartments.filter(item => {
          r.lastIndex = 0
          return r.test(item.Dep_Name)
        })
      } else {
        return this.$store.getters.getDepartments
      }
    },
    filteredHeaders () {
      return this.headers.filter(h => {
        return this.groupBy.indexOf(h.value) === -1
      })
    }
  },
  methods: {
    currentSortBy (e) {
      this.sortBy = e.sortBy[0]
      this.sortDesc = e.sortDesc[0]
    },
    selectAll () {
      this.filter.Project_ID = []
      this.filter.Client_ID = []
      this.filter.Dep_ID = []
      if (this.selectAllProjects) {
        this.$store.getters.getProjects.forEach(item => {
          this.filter.Project_ID.push(item.Project_ID)
        })
      }
      if (this.selectAllClients) {
        this.$store.getters.getClients.forEach(item => {
          this.filter.Client_ID.push(item.Client_ID)
        })
      }
      if (this.selectAllDepartments) {
        this.departments.forEach(item => {
          this.filter.Dep_ID.push(item.Dep_ID)
        })
      }
    },
    groupTitle (item) {
      let str = ''
      for (let i = 0; i < this.groupBy.length; i++) {
        str += item[this.groupBy[i]] ? item[this.groupBy[i]] + (i === this.groupBy.length - 1 ? '' : ', ') : 'Other' + (i === this.groupBy.length - 1 ? '' : ', ')
      }
      return str
    },
    updateDates (e) {
      const d1 = +(new Date(e[0]))
      const d2 = +(new Date(e[1]) || new Date(e[0]))
      if (d1 < d2) this.filter.DateRange = [e[0], e[1]]
      else if (d1 > d2) this.filter.DateRange = [e[1], e[0]]
      else this.filter.DateRange = [e[0], e[1]]
      if (d1 && d2) this.datesMenu = false
    },
    getProjects () {
      this.axios.get('/api/projects', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(response => {
        this.$store.dispatch('setProjects', { projects: response.data })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    getClients () {
      this.axios.get('/api/clients', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(response => {
        this.$store.dispatch('setClients', { clients: response.data })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    getDepartments () {
      this.axios.get('/api/department', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('setDepartments', { departments: res.data })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    }
  }
}
